//
import FamilyModel from '@/models/Warehouse/WhFamily'

/**
 *
 */
const initFamilies = async function() {
    //
    try {
        //
        const response = await FamilyModel.include('wh_subfamilies')
            .params({ get_all_results: true })
            .get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default initFamilies
